// SharedWorkerが使えるかどうかを判定
const isSharedWorkerSupported = () => {
  return typeof SharedWorker !== 'undefined'
}

// SharedWorkerが使える場合はSharedWorker、使えない場合はDedicated Workerを使用
const worker = isSharedWorkerSupported()
  ? new ComlinkSharedWorker<typeof import('../worker/worker')>(
      new URL('../worker/worker', import.meta.url),
      {
        /* normal Worker options*/
      }
    )
  : new ComlinkWorker<typeof import('../worker/worker')>(
      new URL('../worker/worker', import.meta.url),
      {
        /* normal Worker options*/
      }
    )

export const useSharedWorker = () => worker
